import React from 'react';
import { CoursesPage } from './presentation/CoursesPage';
import { useCourses } from './useCourses';

export const CoursesContainer = () => {
    const data = useCourses();
    return <CoursesPage data={data} />;
}